import { Modal } from "antd";
import { ReactNode } from "react";

/**
 * Object to hold UWI entered by the user and their status returned by CORPQRY.
 */
export interface UwiInfo {
  uwi: string;
  status?: string;
}

export const sanitizeUwis = (uwis: string[]): string[] => {
  return uwis.filter((uwi: string) => uwi.length >= 19);
};

export const toUwis = (uwiInfos: UwiInfo[]): string[] => {
  return uwiInfos.map(uwiInfo => uwiInfo.uwi);
};

export const hasDuplicate = (arr: string[], target: string): boolean => {
  const countMap: Record<string, number> = {};
  for (const item of arr) {
    if (item.length === 0) {
      continue;
    }
    if (countMap[item]) {
      countMap[item]++;
    } else {
      countMap[item] = 1;
    }
  }
  return countMap[target] > 1;
};

export const validateMessages = {
  required: '${label} is required',
  types: {
    email: '${label} is not valid',
    number: '${label} is not a valid number',
  },
};

export const showErrorModal = (
  content: ReactNode,
  title?: string,
  afterClose?: () => void,
) => {
  Modal.error({
    title: title || "Error",
    content,
    afterClose,
  });
};

export const showWarningModal = (
  content: ReactNode,
  title?: string,
  okText?: string,
  afterClose?: () => void,
) => {
  Modal.warning({
    title: title || "Warning",
    okText: okText || "OK",
    content,
    afterClose,
  });
};
